import ImpersonatedAccountAlert from "./ImpersonatedAccountAlert"

export default ImpersonatedAccountAlert
